import React, { useCallback, useMemo } from 'react';
import { OfferItemContent } from './components/OfferItemContent';
import { ItemInput } from './components/ItemInput';
import { SelectProductsListItemSkeleton } from './components/SelectProductsListItemSkeleton';
import { VariantItemContent } from './components/VariantItemContent';
import * as S from './styled';
export const SelectProductsListItem = ({ item, mode, selectMode, multiple = false, disabled, disabledMessage, value, onSelect, onBulkSelect, }) => {
    const selectable = multiple || !(selectMode === 'VARIANTS' && item.type === 'OFFER');
    const handleClick = useCallback(() => {
        if (!selectable)
            return;
        if (!multiple && !disabled) {
            onSelect(item.id)(!value);
        }
    }, [selectable, multiple, disabled, onSelect, item.id, value]);
    const input = useMemo(() => (React.createElement(ItemInput, { multiple: multiple, selectMode: selectMode, item: item, value: value, disabled: disabled, onSelect: onSelect, onBulkSelect: onBulkSelect, disabledMessage: disabledMessage })), [multiple, selectMode, item, value, disabled, onSelect, onBulkSelect, disabledMessage]);
    const content = (React.createElement(S.Container, { disabled: disabled, active: multiple ? !!value : value === item.id, selectable: selectable, onClick: handleClick }, item.type === 'VARIANT' ? (React.createElement(VariantItemContent, { item: item, input: input })) : (React.createElement(OfferItemContent, { item: item, input: input, mode: mode }))));
    return multiple ? React.createElement(S.Label, { htmlFor: item.id }, content) : content;
};
SelectProductsListItem.Skeleton = SelectProductsListItemSkeleton;
